module.exports = __webpack_public_path__ + "static/media/text.80d56df5.svg";